module.exports = __webpack_public_path__ + "img/verification_succes.e201df42.jpg";